<template>
  <div class="layout">
    <div class="header">
      <div class="leftLogo">
        <img src="../assets/logo.png" />
        <span></span>
        <div>企业服务系统</div>
      </div>
      <div class="rightMessage">
        <el-dropdown @command="handleCommand" trigger= "click" :hide-on-click= "false">
          <div class="rightIcon">
            <img src="../assets/message.png" />
            <span v-if="messageOneList.length>0 || messageTwoList.length>0"></span>
          </div>
          <el-dropdown-menu slot="dropdown" class="elMessage">
            <div class="messageTab">
              <div class="messageTitle" :class="{'messageActive':isActiveMessage == 1}" @click="getMessageType(1)">待办({{ messageOneList.length }})</div>
              <div class="messageTitle" :class="{'messageActive':isActiveMessage == 2}" @click="getMessageType(2)">通知({{ messageTwoList.length }})</div>
            </div> 
            <div class="messageTabContent">
              <div v-if="isActiveMessage==1">
                <div v-if="messageOneList.length>0" @click="goPage(item.project_type,item.id)" class="messageTabContentList" v-for="(item,index) in this.messageOneList" :key="index">
                  <div class="messageTabContent_title">
                    <span v-if="item.project_type==1">合同立项</span>
                    <span v-if="item.project_type==2">回款计划</span>
                    <span v-if="item.project_type==3">服务费开票</span>
                    <span v-if="item.project_type==4">信息采集</span>
                    <span v-if="item.project_type==5">服务项目</span>
                    <span v-if="item.project_type==6">工单任务</span>
                  </div>
                  <div class="messageTabContent_con">
                    <div class="messageTabContent_con_text">{{ item.content }}</div>
                    <div class="messageTabContent_con_title">{{showText(item.date)}} {{ item.time }}</div>
                  </div>
                </div>
                <div v-if="messageOneList.length==0" class="zanwuImg">
                  <img src="../assets/zanwu.png" />
                  <div>暂无待办事项～</div>
                </div>
              </div>
              <div v-if="isActiveMessage==2">
                <div v-if="messageTwoList.length>0" @click="goPage(item.project_type,item.id)" class="messageTabContentList" v-for="(item,idx) in this.messageTwoList" :key="idx">
                  <div class="messageTabContent_title">
                    <span v-if="item.project_type==1">合同立项</span>
                    <span v-if="item.project_type==2">回款计划</span>
                    <span v-if="item.project_type==3">服务费开票</span>
                    <span v-if="item.project_type==4">信息采集</span>
                    <span v-if="item.project_type==5">服务项目</span>
                    <span v-if="item.project_type==6">工单任务</span>
                  </div>
                  <div class="messageTabContent_con">
                    <div class="messageTabContent_con_text">{{ item.content }}</div>
                    <div class="messageTabContent_con_title">{{item.created_at}}</div>
                  </div>
                </div>
                <div v-if="messageTwoList.length==0" class="zanwuImg">
                  <img src="../assets/zanwu.png" />
                  <div>暂无待办事项～</div>
                </div>
              </div>
            </div>
            <div class="messageTabBottom">
              <div @click="allReadMessage">全部已读</div>
              <div @click="goMessageList()">
                <span>查看全部</span>
                <img src="../assets/more.png" />
              </div>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown @command="handleCommand">
          <div class="messageName">{{this.messageName}}</div>
          <div>
            <el-dropdown-menu slot="dropdown" class="elMessage_2">
              <el-dropdown-item command="information">个人信息</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </div>
        </el-dropdown>
      </div>
    </div>
    <!-- 内容 -->
    <div class="content">
      <el-aside :width="isCollapse?'64px':'192px'">
        <el-menu background-color="#FFFFFF" text-color="#000000" active-text-color="#fff" :unique-opened="false"
          :collapse="isCollapse" :collapse-transition="false" :default-active="activePath" class="slideNav">
          <!-- 一级菜单 -->
          <el-submenu :index="item.id + ''" v-for="(item, index) in slideList" :key="index">
            <!-- 一级菜单的模版区域 -->
            <template slot="title">
              <div :class="['name', subIndex == index ? 'active' : '']" @click="changeSlide(item, index)" ref="slideShow">
                <img :src="[subIndex == index ? item.bigicon : item.icon]" />
                <span>{{ item.name }}</span>
              </div>
            </template>
            <!-- 二级菜单 -->
            <el-menu-item :index="subItem.action" v-for="(subItem, subIndex) in item.all_children" :key="subIndex"
              @click="toPage(subItem,item, index)">
              <template slot="title">
                <!-- 图标 -->
                <!-- <i class="el-icon-menu"></i> -->
                <!-- 文本 -->
                <div :class="[
                                'subItem',
                                subId == subItem.id ? 'subActive' : '',
                            ]">
                  <span :class="['dot',
                                subId == subItem.id ? 'dotActive' : '',
                            ]"></span>{{ subItem.name }}
                </div>
              </template>
            </el-menu-item>
          </el-submenu>
        </el-menu>
        <div class="putAwayBox">
			<img class="putAway" @click="putAway" src="../assets/putAway.png" />
		</div>
      </el-aside>
      <div class="routeWrap">
        <div class="routeContent">
          <router-view v-if="isRouterAlive"></router-view>

        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisiblePass" width="25%" :before-close="handelClose">
      <ForgotPass :username="username" :messageTitle="messageTitle" :message="true" @closeBtn="handelClose">
      </ForgotPass>
    </el-dialog>

  </div>
</template>

<script>
  import {
    router
  } from '@/router/index'
  import Bus from '@/utils/bus.js'
  import ForgotPass from "../components/forgotPass.vue"
  export default {
    name: "layout",
    data() {
      return {
        top: 0,
        left: 0,
        superIndex: 0,
        subIndex: 0,
        slideList: [],
        subId: "",
        dialogVisiblePass: false,
        noticeList: [],
        uid: "",
        userInfo: {},
        isRouterAlive: true,
        form: {
          mobile: "",
          newMobile: "",
          authCode: "",
        },
        count: "获取验证码",
        countDisable: false,
        inter: null,
        noInter: null,
        activeTabItem: "",
        tabs: [{
          closable: false,
          path: "indexList",
          id: 1,
          meta: {
            title: "首页"
          },
        }],
        messageActive: "",
        messageName: "",
        messageMobile: "",
        messageTitle: '修改密码',
        username: "", //手机号
        count: "发送验证码",
        countDisable: false,
        inter: null,
        apply_data: '',
        seen: false,
        isCollapse: false,
        // 被激活的链接地址
        activePath: '',
        messageOneList:[],
        messageTwoList:[],
        isActiveMessage:1,
      };
    },
    created() {
      let id = sessionStorage.getItem("id");
      this.uid = id;
      let token = sessionStorage.getItem("token");
      if (!token) {
        this.$router.push({
          path: "/login",
        });
      } else {
        this.getPermissionTree();
        this.activePath = window.sessionStorage.getItem('activePath')
        
        this.getMessageOne()
        this.getMessageTwo()

        var that = this;
        Bus.$on('isRead',function(type){

          that.getMessageOne()
          that.getMessageTwo()
        })
      }

    },
    components: {
      ForgotPass,
    },
    destroyed() {
      clearInterval(this.inter);
    },
    methods: {
      showText (timeDate) {
        let date = new Date(timeDate)
        let today = new Date()
        today.setHours(0)
        today.setMinutes(0)
        today.setSeconds(0)
        // today 为今天凌晨的时间
        let dayTime = 24 * 60 * 60 * 1000
        let delta = today - date // 得到相差的时间 ms
        if (delta > 0) {
          if (delta <= dayTime) {
            return '昨天'
          } else if (delta <= 2 * dayTime) {
            return '前天'
          }
        } else if (-delta < dayTime) {
          return '今天'
        }
        return timeDate
      },
      getMessageType(type){
        this.isActiveMessage=type
        if(type==1){
          this.getMessageOne()
        }else{
          this.getMessageTwo()
        }
      },
      getMessageOne(){
        let data={
          type:1
        }
        this.$http.get("backend/index", data).then((res) => {
          this.messageOneList=res.data
        });
      },
      getMessageTwo(){
        let data={
          type:2
        }
        this.$http.get("backend/index", data).then((res) => {
          this.messageTwoList=res.data
        });
      },
      allReadMessage(){
        let data={
          type:this.isActiveMessage
        }
        this.$http.get("backend/allRead", data).then((res) => {
          if(res.code==0){
            this.getMessageOne()
            this.getMessageTwo()
          }
        });
      },
      reload() {
        //会刷新页面
        // this.isRouterAlive = false
        // this.$nextTick(function() {
        //   this.isRouterAlive = true
        // })
        this.$nextTick(()=>{
          if(this.$refs.slideShow[0].innerText=='首页'){
            this.$refs.slideShow[0].nextSibling.style.display='none'
            this.$refs.slideShow[0].parentElement.nextSibling.style.marginBottom="0"
          }
        })
      },
      putAway() {
        this.isCollapse = !this.isCollapse
        this.reload()
      },
      handelClose() {
        this.dialogVisiblePass = false
      },
      goMessageList(){
        this.$router.push({
          name:'messageList',
          query:{
            type:this.isActiveMessage
          }
        })
      },
      goPage(type,id){
        this.getReadMessage(id)
        let name
				if(type==1){
					name='approvalManage'
				}else if(type==2){
					name='planManage'
				}else if(type==3){
					name='serviceManage'
				}else if(type==4){
          name='gatherManage'
        }else if(type==5){
          name='projectManage'
        }else if(type==6){
          name='workOrderManage'
        }
        
				this.$store.commit("addUserManage", '');
				this.$router.push({
					name:name,
					query:{
						isShow: "show",
					}
				})
				this.getPermissionTree(type);
      },
      getReadMessage(id) {
        this.$http.get("backend/read/"+id).then((res) => {
          if(res.code==0){
            this.getMessageOne()
            this.getMessageTwo()
          }
        });
      },
      countDown() {
        let self = this;
        self.count = 60;
        self.countDisable = true;
        self.inter = setInterval(function() {
          // console.log("进来");
          if (self.count > 0) {
            self.countDisable = true;
            self.count--;
            // console.log(self.count, "倒计时");
          } else {
            clearInterval(self.inter);
            self.count = "获取验证码";
            self.countDisable = false;
            self.inter = null;
          }
        }, 1000);
      },
      sendYzm() {
        let self = this;
        if (!this.form.mobile) {
          this.$message({
            message: "请输入手机号",
            type: "warning",
          });
          return;
        }
        let data = {
          mobile: this.form.mobile,
        };
        this.countDown();
        this.$http.post("api/me/sms", data).then((res) => {
          console.log(res, "返回验证码");
          if (res.code == 0) {} else {
            self.count = "获取验证码";
            self.countDisable = false;
            this.$message({
              message: res.info,
              type: "warning",
            });
          }
        });
      },
      // 移入
      mouseOver() {
        this.messageActive = "background: rgba(255, 237, 231, .12);";
      },
      // 移出
      mouseLeave() {
        this.messageActive = "";
      },
      handleCommand(command) {
        if (command == "password") {
          this.dialogVisiblePass = true;
        } else if (command == "logout") {
          this.logout();
        } else if (command == "information") {
          this.$router.push({
            name:'information'
          })
        }
      },
      logout() {
        this.$http.get("backend/logout").then((res) => {
          console.log(res, "退出登录");
          sessionStorage.setItem("id", "");
          sessionStorage.setItem("token", "");
          this.$router.push({
            path: "/",
          });
          sessionStorage.setItem('subIndex', 0)
          sessionStorage.setItem('subId', 1)
        });
      },
      changeSlide(item, index) {
        if(item.name=='首页'){
          this.subIndex = index;
          this.toPage(item,index)
        }
        this.subIndex = index;
        sessionStorage.setItem('subIndex', this.subIndex)
      },
      getPermissionTree(type) {
        
        this.$http.get("backend/me").then((res) => {
          this.slideList = res.options
          this.messageName = res.name
          if (this.slideList.length > 0) {
            //刷新保存菜单状态
            this.subIndex = sessionStorage.getItem('subIndex')
            this.subId = sessionStorage.getItem('subId')
            this.slideList[this.subIndex]["select"] = !this.slideList[this.subIndex]["select"];
            
            this.slideList = this.slideList.map((item, index) => {
              if(item.action=='indexList'){
                this.$nextTick(()=>{
                  if(this.$refs.slideShow[0].innerText=='首页'){
                    this.$refs.slideShow[0].nextSibling.style.display='none'
                    this.$refs.slideShow[0].parentElement.nextSibling.style.marginBottom="0"
                  }
                })
              }
              if(type!=1){
                if (item.action == "incomeList" ) {
                  item.all_children.map((children) => {
                    if (children.action == "planManage") {
                      let userManageButton = children.all_children;
                      sessionStorage.setItem(
                        "userManageButton",
                        JSON.stringify(userManageButton)
                      );
                      this.$store.commit("addUserManage", userManageButton);
                    }
                  });
                }else if(item.action == "invoiceList"){
                  item.all_children.map((children) => {
                    if(children.action == "serviceManage"){
                      let arr=children.all_children
                      let userManageButton=arr.concat(children.all_children[0].all_children,children.all_children[1].all_children)
                      sessionStorage.setItem("userManageButton", JSON.stringify(userManageButton));
                      this.$store.commit("addUserManage", userManageButton);
                    }
                  })
                }
              }else{
                if (item.action == "contractList") {
                  item.all_children.map((children) => {
                    if(children.action == "approvalManage"){
                      let userManageButton = children.all_children;
                      sessionStorage.setItem(
                        "userManageButton",
                        JSON.stringify(userManageButton)
                      );
                      this.$store.commit("addUserManage", userManageButton);
                    }
                  });
                }
              }
				
              if (index == this.subIndex) {
                return {
                  ...item,
                  select: true,
                };
              } else {
                return {
                  ...item,
                  select: false,
                };
              }

            });
          }
        })
      },
      toPage(sub,item, index) {
        console.log(sub)
        console.log(sub.name, "页面name");
        this.subId = sub.id;
        sessionStorage.setItem('subId', this.subId)
        let button = sub.all_children;
        let buttonArr=[]
        button.map((item)=>{
          if(item.action=='serviceManage' || item.action=='waitServiceManage'){
            
            item.all_children.map((it)=>{
              buttonArr.push(it)
            })
            sessionStorage.setItem("button", JSON.stringify(buttonArr));
            this.$store.commit("addPermission", buttonArr);
          }else{
            if (button) {
                sessionStorage.setItem("button", JSON.stringify(button));
                this.$store.commit("addPermission", button);
            } else {
                sessionStorage.setItem("button", []);
                this.$store.commit("addPermission", []);
            }
          }
        })
        
        window.sessionStorage.setItem('activePath', sub.action)
        this.activePath = sub.action

        this.$router.push({
          name: sub.action,
          query: {
            subIndex: index,
            superIndex: this.superIndex,
            pageId: sub.id,
          },
        });
        this.$store.commit('addInvoiceForm','')
			  this.$store.commit('addAddresForm','')
        this.$store.commit("addUserManage", '');
        this.$store.commit("addBillingContent", "");
        sessionStorage.removeItem('formSearchList')
		
		    this.changeSlide(item,index)
		
        //删除表格保存的页数、每页条数、tab切换状态
        localStorage.removeItem("pagination");
        localStorage.removeItem("pageSizeNumber");
        localStorage.removeItem("paginationChild");
        localStorage.removeItem("pageSizeNumberChild");
        localStorage.removeItem("pagination2");
        localStorage.removeItem("pageSizeNumber2");
        sessionStorage.removeItem("currentTab");
        sessionStorage.removeItem("currentTab_1");


      },

    },
  };
</script>
<style>
.el-menu-item.is-active{
  color: #333 !important;
}
.el-menu-item .subItem {
  display: flex;
  align-items: center;
  height: 40px;
  margin-bottom: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
}
.el-menu-item .subActive {
  color: #666;
}
.el-menu--popup .el-menu-item{
  margin: 6px 12px;
  padding-left: 0 !important;
}
.el-menu--popup .el-menu-item .subItem{
  margin-left: 4px;
}
.el-menu--popup .el-menu-item:hover .subItem{
  margin-left: 4px !important;
}
.el-menu--popup .el-menu-item.is-active{
  background: none !important;
  border-radius: 2px;
}
.el-menu--collapse .el-submenu .active{
  background: #FFF7F7;
  border-radius: 2px;
}
.el-menu--vertical{
	left:56px !important;
}
.el-menu--popup{
	min-width: 112px !important;
}
.el-menu--popup .el-menu-item:hover{
  background: none !important;
  font-weight: 600;
  margin: 6px 12px;
  border-radius: 2px;
  color: #333;
}
.el-submenu .el-menu-item:hover{
  background: #FFF7F7 !important;
  margin: 6px 12px;
  border-radius: 2px;
  padding: 0 !important;
}
.el-submenu .el-menu-item:hover .subItem{
	color:#333 !important;
}
.el-submenu .el-menu-item:hover .subItem .dot{
	border-color:#333 !important;
}
.el-menu-item:hover .subItem{
  color: #333 !important;
  margin-left: 36px;
  padding-left: 0 !important;
}
.el-menu--collapse{
  width: 64px !important;
}
.el-menu-item{
  height: 40px !important;
  line-height: 40px !important;
  margin-bottom: 6px !important;
  font-size: 14px !important;
}
 .el-submenu__title .name+i{ /* 找平级 */
   color:#999 !important;
   font-weight: 700;
 }
 .el-submenu__title .active+i{ /* 找平级 */
   color:#fff !important;
   font-weight: 700;
 }
</style>
<style lang="less" scoped>
  .elMessage{
    width: 400px;
    height: 440px;
    padding: 0;
    display: flex;
    flex-direction: column;
    .messageTab{
      display: flex;
      border-bottom: 1px solid #E2E4EB;
      padding-left: 20px;
      padding-top: 16px;
      .messageTitle{
        font-size: 16px;
        font-weight: 600;
        color: #C6C6C6;
        margin-right: 40px;
        padding-bottom: 4px;
        cursor: pointer;
      }
      .messageActive{
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        border-bottom: 2px solid #DB3323;
      }
    }
    .messageTabContent{
      height: 345px;
      padding-bottom: 20px;
      box-sizing: border-box;
      overflow: auto;
      flex: 1;
      margin: 0 20px;
      margin-right: 0;
      padding-right: 20px;
      border-bottom: 1px solid #E2E4EB;
      .messageTabContentList:hover{
        cursor: pointer;
      }
      .messageTabContentList{
        .messageTabContent_title{
          font-size: 14px;
          font-weight: 600;
          color: #333333;
          margin-top: 20px;
          margin-bottom: 4px;
        }
        .messageTabContent_con{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .messageTabContent_con_text{
            font-size: 12px;
            font-weight: 400;
            color: #666;
          }
			.messageTabContent_con_text:hover{
			  text-decoration: underline;
			  color: #333;
			}
          .messageTabContent_con_title{
            font-size: 12px;
            font-weight: 400;
            color: #666666;
          }
        }
      }
      .zanwuImg{
        margin-top: 100px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        img{
          width: 64px;
          margin-bottom: 4px;
        }
        div{
          font-size: 14px;
          font-weight: 400;
          color: #999999;
        }
      }
    }
    .messageTabBottom{
      margin: 0 20px;
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      div{
        cursor: pointer;
        img{
          width: 12px;
        }
      }
    }
  }
  .elMessage_2{
    width: 112px;
  }

  .layout {
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    overflow: hidden;

    .header {
      width: 100%;
      height: 56px;
      background: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .leftLogo {
        display: flex;
        align-items: center;
        margin-left: 24px;

        img {
          width: 101px;
          margin-right: 4px;
          display: block;
        }

        span {
          width: 1px;
          height: 16px;
          display: block;
          background: #E2E4EB;
        }

        div {
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          padding-left: 8px;
        }
      }

      .rightMessage {
        display: flex;
        margin-right: 40px;

        .rightIcon {
          position: relative;
          margin-right: 20px;
          cursor: pointer;
          img {
            width: 20px;
          }

          span {
            position: absolute;
            top: 0;
            right: 2px;
            width: 7px;
            height: 7px;
            background: #FF2131;
            border: 1px solid #FFFFFF;
            border-radius: 50%;
            display: block;
			box-sizing: border-box;
          }
        }

        .messageName {
          font-size: 14px;
          font-weight: 600;
          color: #333333;
          cursor: pointer;
        }
      }
    }

    .content {
      display: flex;
      // height: calc(100vh - 82px);
      height: calc(100vh - 56px);
      border-top: 1px solid #F6F8FB;
      box-sizing: border-box;
	  .putAwayBox{
		  margin:0 12px;
		  padding: 20px 12px;
		  border-top:1px solid #E2E4EB;
		  .putAway {
			width: 20px;
			cursor: pointer;
		  }
	  }
      /deep/ .el-submenu:nth-child(1){
         .el-submenu__icon-arrow{
          //  display: none;
         }
      }
      .el-aside {
        margin-top: 12px;
		display: flex;
		flex-direction: column;
      }
      .el-menu--collapse{
        width: 44px;
      }

      .slideNav {
		  flex: 1;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        // width: 176px;
        height: 100%;
        background: #ffffff;
        border-right: none;
		padding: 0 12px;
		box-sizing:border-box;

        /deep/ .el-submenu__title {
          // margin: 0 12px;
          margin-bottom: 6px;
          padding: 0;
          padding-left: 0 !important;
          height: 40px;
          line-height: 40px;
        }

        /deep/ .el-submenu .el-menu-item {
          // padding: 0 12px !important;
        }

        /deep/ .el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow {
          // color: #fff;
          font-weight: bold;
        }
		/deep/ .el-submenu .el-menu{
			background-color: rgba(245,247,250,0.6) !important;
			border-radius: 4px;
			margin-bottom: 6px;
		}
        /deep/ .el-submenu .el-menu-item {
          box-sizing: border-box;
          padding: 0 !important;
		  background-color: rgba(250,250,250,0) !important;
          height: 40px;
          line-height: 40px;
          margin: 6px auto;
          margin-top: 0;
		  min-width: 168px;
        }
        /deep/ .el-submenu__title:hover {
          background: none !important;
          margin-bottom: 6px;
          border-radius: 2px;
          span{
            font-weight: 600;
          }
        }

        .name {
          display: flex;
          align-items: center;
          height: 40px;
          // background: #eeeeee;
          cursor: pointer;
          padding-left: 12px;

          span {
            font-weight: 400;
            font-size: 14px;
            color: #333;
          }

          img {
            width: 16px;
            margin-right: 8px;
          }
        }
        .active{
			background: #DB3323;
			border-radius: 4px;
          span{
            font-weight: 600;
            color: #FFFFFF;
          }
        }

        .subItem {
          display: flex;
          align-items: center;
          height: 40px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 400;
          color: #999;
          padding-left: 36px;
		  .dot{
			  width: 6px;
			  height: 6px;
			  border: 1px solid #D4D4D4;
			  border-radius: 50%;
			  margin-right: 8px;
		  }
        }

        .subActive {
          color: #DB3323;
		  .dotActive{
			  width: 6px;
			  height: 6px;
			  border: 1px solid #DB3323;
			  border-radius: 50%;
			  margin-right: 8px;
		  }
        }
      }

      .routeWrap {
        display: flex;
        flex-direction: column;
        flex: 1;
        // background: blue;
        overflow-x: hidden;
        // background: #eeeeee;
        background: #F7F8FB;

        .tabAll {
          width: 100%;
          height: 40px;
          background-color: #fff;
          padding: 0 24px;
          box-sizing: border-box;

          .el-tabs__item {
            position: relative;
          }

          .closeMenu {
            z-index: 100;
            background: #fff;
            padding: 10px 0;
            text-align: center;
            position: absolute;

            div {
              padding: 0 20px;
              line-height: 30px;
              cursor: pointer;
              font-size: 14px;

              &:hover {
                background: #eee;
              }
            }
          }
        }

        .routeContent {
          display: flex;
          flex-direction: column;
          flex: 1;
          overflow-x: hidden;
          padding: 16px;
        }
      }
    }

  }
  /deep/ .el-submenu__icon-arrow{
	  right: 12px !important;
  }

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background-color: #EFF1F4;
  }

  /* 滚动条的滑轨背景颜色 */

  ::-webkit-scrollbar-thumb {
    width: 4px !important;
    height: 26px;
    background-color: #D4D6DA;
    border-radius: 8px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/page/layout.vue